import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function Hero() {
  return <section className="relative min-h-[90vh] flex items-center bg-cream overflow-hidden py-20 lg:py-0" data-id="element-110">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 w-full grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-111">
        <div className="max-w-2xl" data-id="element-112">
          <FadeIn data-id="element-113">
            <div className="mb-8 w-36 h-36 animate-[spin_20s_linear_infinite]" data-id="element-114">
              <img src="https://cdn.magicpatterns.com/uploads/b6PAqfknJZN8FKpicFn2RA/Readiness__Resilience_Leadership_Foundation_(2).png" alt="LeadHerShip Equity logo" className="w-full h-full object-contain" data-id="element-115" />
            </div>
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold leading-tight mb-6 text-navy" data-id="element-116">
              Lead
              <em className="font-light italic text-transparent bg-clip-text bg-gradient-to-r from-blush to-berry-light" data-id="element-117">
                Her
              </em>
              Ship Equity
            </h1>
          </FadeIn>

          <FadeIn delay={0.1} data-id="element-118">
            <p className="text-xl md:text-2xl font-serif text-navy mb-6" data-id="element-119">
              A membership for women building businesses and getting ready to be
              funded—with real strategy, community, and access to the right
              rooms.
            </p>
          </FadeIn>

          <FadeIn delay={0.2} className="space-y-4" data-id="element-120">
            <a href="https://buy.stripe.com/bJe14m74m5KjgWygiMf3a07" target="_blank" rel="noopener noreferrer" className="block w-full bg-gradient-to-r from-blush to-blush-light hover:from-blush-light hover:to-white text-maroon font-bold text-lg py-4 px-8 rounded-md transition-all duration-300 shadow-lg hover:shadow-xl text-center" data-id="element-121">
              Join FundHER Academy for $0.99
            </a>
            <p className="text-xs text-center text-gray-400" data-id="element-122">
              Start for $0.99. Then $24/month. Cancel anytime.
            </p>
          </FadeIn>
        </div>

        <FadeIn delay={0.4} direction="left" className="relative h-[500px] lg:h-[700px] w-full rounded-2xl overflow-hidden shadow-2xl" data-id="element-123">
          <img src="https://cdn.magicpatterns.com/uploads/t9wxPqfKCXK5TTRYLjAMnx/Beignets_2B_Carats__Bridal_Shower_Inspiration___Munaluchi_Bride_(1).jpg" alt="Women celebrating at a LeadHerShip Equity event" className="absolute inset-0 w-full h-full object-cover" data-id="element-124" />
        </FadeIn>
      </div>
    </section>;
}